import { render, staticRenderFns } from "./ConsultationsNumbers.vue?vue&type=template&id=575fcd36&scoped=true"
import script from "./ConsultationsNumbers.vue?vue&type=script&lang=js"
export * from "./ConsultationsNumbers.vue?vue&type=script&lang=js"
import style0 from "./ConsultationsNumbers.vue?vue&type=style&index=0&id=575fcd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575fcd36",
  null
  
)

export default component.exports